module.exports = __webpack_public_path__ + "img/1954_uk.95a0ba44.svg";